import { useGet } from "../Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import TYPE_RESSOURCE from "../../enum/TypeRessource.tsx";
import Ressource from "./Ressource.tsx";

type RessourceByCodeType = {
  code: string;
  type: TYPE_RESSOURCE;
  prive?: boolean;
};
/**
 * Composant React représentant une ressource.
 * Ce composant affiche une ressource sous plusieurs formes (PDF, VIDEO...), en fonction du type spécifié.
 * La ressource peut être téléchargeable ou non, et est définie par une entité RessourceEntity.
 */
const RessourceByCode = ({ code, type, prive = true }: RessourceByCodeType) => {
  //si on veut un ressource public il faut le préciser
  const ressource = useGet(
    prive
      ? url`/api/ressource/get-ressource/` + code
      : url`/api/public/ressource/get-ressource/` + code,
    {},
  );

  if (!ressource.isResolved) {
    return;
  }
  return (
    <Ressource
      ressource={{
        url: ressource.data?.url,
        telechargeable: ressource.data?.telechargeable,
        soustitre: ressource.data?.soustitre,
      }}
      type={type}
    />
  );
};

export default RessourceByCode;
